import Header from './Header';
import Layout from '../Layout';
import { BORDER_WIDTH } from '../Table/constants';
import { Column, ColumnWidthProps, Row, SortFilterProps } from '../Table/types';

interface Props<T extends Row> extends SortFilterProps, ColumnWidthProps {
  columns: Column<T>[];
  style: React.CSSProperties;
  disableTableControlsHeader: boolean;
}

const HeaderRow = <T extends Row>({
  style,
  columns,
  sortState,
  setSortState,
  setColumnWidths,
  getColumnWidth
}: Props<T>) => {
  return (
    <Layout
      position="sticky"
      zIndex={30}
      align="center"
      color="white"
      __style={{ ...style, top: '0px' }}
      borderBottom
      borderColor="gray-50"
    >
      {/** This element covers up tiny gap between header and table where a crack of text can appear. */}
      <Layout position="absolute" top={-BORDER_WIDTH} color="white" __style={{ height: BORDER_WIDTH }} width="100%" />
      {columns.map(
        ({
          header,
          key: columnKey,
          sortBy,
          shrinkWidth,
          flexGrow,
          minWidth,
          maxWidth,
          width,
          Header: CustomHeader
        }) => {
          const key = columnKey as string;
          const sortStateIndex = sortState.findIndex(sort => sort.key === key);
          const sort = sortState[sortStateIndex];

          return (
            <Header
              key={key}
              columnKey={key}
              value={header}
              setSortState={direction => {
                const updatedSortState = direction === null ? [] : [{ key, direction }];

                setSortState(updatedSortState);
              }}
              setColumnWidths={setColumnWidths}
              getColumnWidth={getColumnWidth}
              flexGrow={flexGrow}
              CustomHeader={CustomHeader}
              minWidth={minWidth}
              maxWidth={maxWidth}
              width={width}
              shrinkWidth={!!shrinkWidth}
              activeSortDirection={sort ? sort.direction : undefined}
              sortable={!!sortBy}
            />
          );
        }
      )}
    </Layout>
  );
};

export default HeaderRow;
